import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import { API } from "aws-amplify";
import "./BatchAnalytics.scss";
import config from "../../../config/aws-exports";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import EnhancedTable from "./Table/EnhancedTable";
import { useSelector, useDispatch } from "react-redux";
import { authData, awsSignIn } from "../../../redux/auth/authSlice";
import produce from "immer";

function CircularProgressWithLabel(props) {
  return (
    <div style={{ position: "relative" }}>
      <Box
        position="relative"
        display="inline-flex"
        style={{ width: "100px", height: "100px", zIndex: "7" }}
      >
        <CircularProgress
          size={100}
          thickness={2.5}
          variant="determinate"
          style={{
            borderRadius: "50%",
            color: "#0f80a4",
          }}
          {...props}
        />

        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
            style={{
              fontSize: "22px",
              fontWeight: "500",
              color: "black",
            }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
      <Box
        position="absolute"
        display="inline-flex"
        style={{ width: "100px", height: "100px", left: "0%" }}
      >
        <CircularProgress
          size={100}
          thickness={2.5}
          variant="determinate"
          style={{ color: "#77777777" }}
          value={100}
        />
      </Box>
    </div>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function CircularStatic(props) {
  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) =>
  //       prevProgress >= 100 ? 0 : prevProgress + 10
  //     );
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  return <CircularProgressWithLabel value={props.progress} />;
}

export default function BatchAnalytics(props) {
  const {batchAnalytics, progress, loading, per, userscount} = props;
  const [courseId, setCourseId] = useState({});
  console.log("insside batch", batchAnalytics);
  return (
    <div className="BatchAnalytics">
      <div className="BatchAnalytics__container">
        {userscount !== 0 && (
            <div>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  "& > :not(style)": {
                    m: 1,
                    width: 270,
                    height: 170,
                  },
                }}
              >
                <Paper elevation={3} style={{ padding: "1.5rem" }}>
                  <h3 style={{ marginBottom: "1.5rem" }}>
                    Users completed the Course
                  </h3>
                  <div
                    style={{
                      position: "relative",
                      padding: "0 2.6rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <CircularStatic progress={per} />

                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontSize: "1.5rem", fontWeight: "600" }}>
                        {progress}/{batchAnalytics.length}
                      </span>
                      <span style={{ fontSize: "1.5rem", fontWeight: "600" }}>
                        Users
                      </span>
                    </div>
                  </div>
                </Paper>
              </Box>
            </div>
        )}
      </div>

      {!loading && userscount !== 0 && (
        <EnhancedTable batchAnalytics={batchAnalytics} courseId={courseId} />
      )}
      {userscount === 0 && (
        <>
          <h2 style={{ textAlign: "center" }}>No Users</h2>
        </>
      )}
    </div>
  );
}
